import { motion } from 'motion/react'
import { forwardRef, useLayoutEffect } from 'react'
import { Button } from '@/components/shadcn/button'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/shadcn/popover'
import { IconV2FilterOutline } from '@icons/IconV2FilterOutline'
import { IconPinboardOutline } from '@icons/IconPinboardOutline'
import { PageFiltersPopoverContent } from '../FiltersPanel'
import { useAppPageState } from '../useAppPageState'
import { useFiltersLayout } from '../FiltersLayoutContext'

export const HeaderActions = forwardRef<HTMLDivElement>((_props, ref) => {
  const { isConfiguringLayout, toggleIsConfiguringLayout, showFilters, setFilterPopoverOpen } = useAppPageState()
  const { unPinnedFilters } = useFiltersLayout()
  const hasUnPinnedFilters = unPinnedFilters.length > 0
  const showFilterTrigger = hasUnPinnedFilters || isConfiguringLayout

  useLayoutEffect(() => {
    if (!showFilterTrigger) {
      setFilterPopoverOpen(false)
    }
  }, [showFilterTrigger, setFilterPopoverOpen])

  return (
    <motion.div ref={ref} layout className="flex gap-x-1">
      <Button
        variant={isConfiguringLayout ? 'default' : 'ghost'}
        className={isConfiguringLayout ? '' : 'hidden'}
        size="icon"
        onClick={toggleIsConfiguringLayout}
      >
        <IconPinboardOutline className="size-5" />
      </Button>
      {showFilterTrigger ? (
        <Popover open={showFilters} onOpenChange={setFilterPopoverOpen}>
          <PopoverTrigger asChild>
            <Button variant="ghost" size="icon" className="p-0">
              <span className="inline-flex items-center">
                <span className="font-bold">...</span>
                <IconV2FilterOutline className="size-5" />
              </span>
              <span className="sr-only">Open filters</span>
            </Button>
          </PopoverTrigger>
          <PopoverContent
            portal
            align="end"
            collisionPadding={16}
            onCloseAutoFocus={(event) => event.preventDefault()}
            className="max-h-[min(80vh,var(--radix-popover-content-available-height))] w-96 overflow-y-auto rounded-xl bg-offwhite"
          >
            <PageFiltersPopoverContent />
          </PopoverContent>
        </Popover>
      ) : null}
    </motion.div>
  )
})

HeaderActions.displayName = 'HeaderActions'
